import React, { useState, useEffect } from 'react';
import API_HOST from '../config';

function SearchForm({ userRequest, setTripOrder, handleTotalSearch }) {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const Overlay = () => (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        color: 'white',
        fontSize: '24px'
      }}>
        Loading...
      </div>
    </div>
  );

  useEffect(() => {
    // Always try to populate from userRequest when it changes.
    console.log('[SearchForm useEffect] Hook triggered. userRequest:', userRequest);

    if (userRequest) {
      // Populate legs
      if (Array.isArray(userRequest.legs) && userRequest.legs.length > 0 && userRequest.legs[0]) {
        const firstLeg = userRequest.legs[0];
        console.log('[SearchForm useEffect] Populating from firstLeg:', firstLeg);
        setFrom(firstLeg.departureAirportCode || '');
        setTo(firstLeg.arrivalAirportCode || '');
        setStart(firstLeg.departureDate || '');

        if (userRequest.legs.length > 1 && userRequest.legs[1]) {
          const secondLeg = userRequest.legs[1];
          console.log('[SearchForm useEffect] Populating end date from secondLeg:', secondLeg);
          setEnd(secondLeg.departureDate || '');
        } else {
          console.log('[SearchForm useEffect] No second leg for end date. Resetting "End Date".');
          setEnd('');
        }
      } else {
        console.log('[SearchForm useEffect] userRequest.legs not suitable for populating leg fields. Resetting them.');
        setFrom('');
        setTo('');
        setStart('');
        setEnd('');
      }

      // Passenger counts are no longer managed here
    } else {
      // userRequest is null/undefined, reset everything
      console.log('[SearchForm useEffect] userRequest is falsy. Resetting leg form fields.');
      setFrom('');
      setTo('');
      setStart('');
      setEnd('');
    }
  }, [userRequest]);

  const isFormValid = () => {
    return from && to && start && end && new Date(end) >= new Date(start);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isFormValid()) return;

    setIsLoading(true);

    const requestBody = {
      flightRequestId: "000",
      legs: [
        { departureAirportCode: from, arrivalAirportCode: to, departureDate: start },
        { departureAirportCode: to, arrivalAirportCode: from, departureDate: end }
      ]
    };

    try {
      const response = await fetch(`${API_HOST}/api/trip/trip_order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Response data:', data);

      // Update the tripOrder state with the response data
      setTripOrder(data);

      // Update the URL with the new trip order ID
      if (data.id) {
        window.history.pushState({}, '', `/${data.id}`);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="From"
          value={from}
          onChange={(e) => setFrom(e.target.value.toUpperCase())}
          required
        />
        <input
          type="text"
          placeholder="To"
          value={to}
          onChange={(e) => setTo(e.target.value.toUpperCase())}
          required
        />
        <input
          type="date"
          value={start}
          onChange={(e) => setStart(e.target.value)}
          required
        />
        <input
          type="date"
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          required
          min={start}
        />
        {/* Passenger Inputs removed */}
        {/* Add the Total Search button before the Generate button */}
        {/* Ensure handleTotalSearch is passed and is a function before rendering */}
        {typeof handleTotalSearch === 'function' && (
          <button
            type="button"
            onClick={() => {
              if (!isFormValid()) {
                // Optionally, provide user feedback about invalid form
                console.warn("Search form is invalid for Total Search.");
                alert("Please fill all fields correctly (From, To, Start Date, End Date) and ensure End Date is not before Start Date.");
                return;
              }
              const currentLegs = [
                {
                  departureAirportCode: from,
                  arrivalAirportCode: to,
                  departureDate: start,
                  bookingClass: "ECONOMY" // Default as specified
                },
                {
                  departureAirportCode: to,
                  arrivalAirportCode: from,
                  departureDate: end,
                  bookingClass: "ECONOMY" // Default as specified
                }
              ];
              console.log('SearchForm.js: currentLegs to be passed:', currentLegs);
              handleTotalSearch(currentLegs);
            }}
            // Optionally disable if form is invalid, similar to Generate button
            // disabled={!isFormValid()}
          >
            Search
          </button>
        )}
      </form>
      {isLoading && <Overlay />}
    </>
  );
}

export default SearchForm;
